import numeral from 'numeral';

const formatNumber = (number: number | string) => numeral(number).format();

const createArrayOfZeros = (length: number) => Array.from({ length }, () => 0);

export {
  formatNumber,
  createArrayOfZeros,
};
